
import { useState } from "react";
import { 
  Dialog,
  DialogContent, 
  DialogHeader, 
  DialogTitle,
  DialogFooter
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AlertTriangle } from "lucide-react";

export default function DeleteFolderConfirmDialog({ 
  isOpen, 
  onClose, 
  folder, 
  onConfirm 
}) {
  const [confirmText, setConfirmText] = useState("");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (confirmText !== "CONFIRM") return;
    
    setLoading(true);
    try {
      await onConfirm(folder._id, confirmText);
      setConfirmText("");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setConfirmText("");
    onClose();
  };

  if (!folder) return null;

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Delete Folder
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-sm text-red-800">
              <strong>Warning:</strong> This action cannot be undone. The folder "{folder.name}" will be permanently deleted.
            </p>
            {folder.candidateCount > 0 && (
              <p className="text-sm text-red-800 mt-2">
                <strong>{folder.candidateCount} candidate(s)</strong> in this folder will be moved to "Others".
              </p>
            )}
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="confirm-text">
              Type <strong>CONFIRM</strong> to delete this folder:
            </Label>
            <Input
              id="confirm-text"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type CONFIRM here"
              className={confirmText === "CONFIRM" ? "border-red-500" : ""}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button 
            variant="destructive" 
            onClick={handleConfirm}
            disabled={confirmText !== "CONFIRM" || loading}
          >
            {loading ? "Deleting..." : "Delete Folder"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
